import { render } from "./ReleaseGroupCommissionPartial.vue?vue&type=template&id=7e868ed4"
import script from "./ReleaseGroupCommissionPartial.vue?vue&type=script&lang=js"
export * from "./ReleaseGroupCommissionPartial.vue?vue&type=script&lang=js"

import "./ReleaseGroupCommissionPartial.vue?vue&type=style&index=0&id=7e868ed4&lang=css"
script.render = render

export default script